import type { Brain } from '@plone/types';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import styles from './styles.module.css';
import BowlingCenterCard from './BowlingCenterCard';
import { getBowlingCenterProductsIcon } from '@redturtle/qubicaamf-theme/actions';
import { useLocation } from 'react-router-dom';
import config from '@plone/registry';

interface BowlingCenterCardTemplateProps {
  items: Brain[];
  block: string;
  query: any;
}

const BowlingCenterCardTemplate = (props: BowlingCenterCardTemplateProps) => {
  const { items, block, query } = props;
  const Container = config.getComponent('Container').component || 'div';
  // @ts-expect-error
  const producticons = useSelector((store) => store.bowlingcenterproductsicon);
  let location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBowlingCenterProductsIcon());
  }, [dispatch, location]);

  return (
    <Container
      className={cx('block-listing-bowlingcenter', styles.bowlingcenterlisting)}
    >
      {items.map((item, index) => {
        return (
          <BowlingCenterCard
            key={index}
            item={item}
            producticons={producticons}
            block={block}
            query={query}
          />
        );
      })}
    </Container>
  );
};

export default BowlingCenterCardTemplate;
